export const isValidEmailAddress = (email: string): boolean => {
  // Define the regular expression to match email addresses
  const emailRegex =
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

  // Check if the email matches the regular expression
  const isEmailValid = emailRegex.test(email);

  // Return false if the email is empty or doesn't match the regular expression, true otherwise
  return Boolean(email) && isEmailValid;
};
